import { ConfirmationModal } from "@/components/ui/ConfirmationModal/ConfirmationModal";

interface PublishConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function PublishConfirmModal({ isOpen, onClose, onConfirm }: PublishConfirmModalProps) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title="Publish changes?"
      body="New visits will use this version. Visits already filled keep the version they started with."
      confirmText="Publish changes"
      size="md"
      onConfirm={onConfirm}
    />
  );
}
